import { Component } from '@angular/core';
import { soundpostAccountingAllocationRuleEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Accounting Allocation Rules') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostaccountingallocationrule-form',
    templateUrl: './soundpostaccountingallocationrule.form.component.html'
})
export class soundpostAccountingAllocationRuleFormComponent extends BaseFormComponent {
    public record!: soundpostAccountingAllocationRuleEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'accountingEntries', sectionName: 'Accounting Entries', isExpanded: false }
        ]);
    }
}

